
import React, { useState } from 'react';

const TaskManagement = ({ staff, onNavigate }) => {
  const [selectedFloor, setSelectedFloor] = useState(1);
  const [selectedView, setSelectedView] = useState('tasks');
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [selectedDirtyRoom, setSelectedDirtyRoom] = useState(null);
  
  // Sample staff data
const staffList = [
  { id: 1, name: 'Rajesh Kumar', role: 'Senior Housekeeper', shift: 'Morning', tasks: 3, rating: 4.8, avatar: '👨' },
  { id: 2, name: 'Priya Sharma', role: 'Housekeeping Supervisor', shift: 'Morning', tasks: 2, rating: 4.9, avatar: '👩' },
  { id: 3, name: 'Amit Patel', role: 'Housekeeper', shift: 'Afternoon', tasks: 4, rating: 4.5, avatar: '👨' },
  { id: 4, name: 'Sneha Reddy', role: 'Floor Manager', shift: 'Morning', tasks: 1, rating: 4.7, avatar: '👩' },
  { id: 5, name: 'Vikram Singh', role: 'Housekeeper', shift: 'Night', tasks: 2, rating: 4.4, avatar: '👨' },
  { id: 6, name: 'Anjali Desai', role: 'Housekeeper', shift: 'Morning', tasks: 3, rating: 4.6, avatar: '👩' },
  { id: 7, name: 'Rahul Verma', role: 'Quality Inspector', shift: 'Afternoon', tasks: 5, rating: 4.8, avatar: '👨' }
];

  // Sample rooms data by floor
  const [roomsByFloor, setRoomsByFloor] = useState({
    1: [
      { id: 101, status: 'dirty', priority: 'high', assignedTo: null, lastCleaned: '2024-01-14', guestName: 'Mr. Smith', issues: ['Stain on carpet', 'Missing towel'], reportedBy: 'Guest', reportedAt: '2024-01-15 09:30 AM' },
      { id: 102, status: 'clean', priority: 'normal', assignedTo: 'John Doe', lastCleaned: '2024-01-15', guestName: 'Mrs. Johnson' },
      { id: 103, status: 'occupied', priority: 'normal', assignedTo: null, guestName: 'Mr. Williams' },
      { id: 104, status: 'dirty', priority: 'urgent', assignedTo: null, lastCleaned: '2024-01-13', guestName: 'Dr. Brown', issues: ['Broken lamp', 'Dirty bathroom'], reportedBy: 'Housekeeping', reportedAt: '2024-01-15 08:00 AM' },
      { id: 105, status: 'clean', priority: 'normal', assignedTo: 'Sarah Smith', lastCleaned: '2024-01-15', guestName: 'Ms. Davis' },
    ],
    2: [
      { id: 201, status: 'dirty', priority: 'normal', assignedTo: null, lastCleaned: '2024-01-14', guestName: 'Family Lee', issues: ['Trash not emptied'], reportedBy: 'Guest', reportedAt: '2024-01-15 10:15 AM' },
      { id: 202, status: 'clean', priority: 'normal', assignedTo: 'Mike Johnson', lastCleaned: '2024-01-15', guestName: 'Mr. Taylor' },
      { id: 203, status: 'occupied', priority: 'high', assignedTo: null, guestName: 'VIP Guest' },
      { id: 204, status: 'dirty', priority: 'urgent', assignedTo: null, lastCleaned: '2024-01-12', guestName: 'Mr. Anderson', issues: ['Water leakage'], reportedBy: 'Maintenance', reportedAt: '2024-01-15 07:45 AM' },
      { id: 205, status: 'clean', priority: 'normal', assignedTo: 'Emma Wilson', lastCleaned: '2024-01-15', guestName: 'Ms. Martin' },
    ],
    3: [
      { id: 301, status: 'dirty', priority: 'normal', assignedTo: null, lastCleaned: '2024-01-13', guestName: 'Mr. White', issues: ['Dust on furniture', 'Dirty windows'], reportedBy: 'Guest', reportedAt: '2024-01-15 11:00 AM' },
      { id: 302, status: 'clean', priority: 'normal', assignedTo: 'David Brown', lastCleaned: '2024-01-15', guestName: 'Mrs. Green' },
      { id: 303, status: 'occupied', priority: 'normal', assignedTo: null, guestName: 'Family Black' },
    ],
    4: [], 5: [], 6: [], 7: [], 8: [], 9: [], 10: []
  });

  // Dirty room images state
  const [dirtyRoomImages, setDirtyRoomImages] = useState({});
  const [imageUploadStatus, setImageUploadStatus] = useState({});
  const [selectedImageForPreview, setSelectedImageForPreview] = useState(null);

  // Sample feedback data
  const [feedbacks] = useState([
    { id: 1, roomId: 101, guestName: 'Mr. Smith', rating: 5, comment: 'Excellent service! Very clean room.', date: '2024-01-15', category: 'cleaning' },
    { id: 2, roomId: 102, guestName: 'Mrs. Johnson', rating: 4, comment: 'Good service, but late check-in.', date: '2024-01-14', category: 'service' },
    { id: 3, roomId: 201, guestName: 'Family Lee', rating: 3, comment: 'Room was not ready on time.', date: '2024-01-13', category: 'timing' },
    { id: 4, roomId: 205, guestName: 'Ms. Martin', rating: 5, comment: 'Amazing hospitality! Will come again.', date: '2024-01-15', category: 'hospitality' },
  ]);

  // Sample lost & found items
  const [lostFoundItems, setLostFoundItems] = useState([
    { id: 1, item: 'iPhone 14', roomId: 103, guestName: 'Mr. Williams', status: 'pending', date: '2024-01-15', description: 'Black iPhone with red case' },
    { id: 2, item: 'Wallet', roomId: 105, guestName: 'Ms. Davis', status: 'claimed', date: '2024-01-14', description: 'Brown leather wallet' },
    { id: 3, item: 'Sunglasses', roomId: 202, guestName: 'Mr. Taylor', status: 'pending', date: '2024-01-13', description: 'Ray-Ban sunglasses' },
    { id: 4, item: 'Laptop Charger', roomId: 301, guestName: 'Mr. White', status: 'returned', date: '2024-01-12', description: 'Dell laptop charger' },
    { id: 5, item: 'Suitcase', roomId: 204, guestName: 'Mr. Anderson', status: 'pending', date: '2024-01-15', description: 'Black Samsonite suitcase' },
  ]);

  // Task assignments
  const [assignments, setAssignments] = useState([
    { id: 1, roomId: 101, staffId: 1, status: 'pending', assignedAt: '2024-01-15 09:00 AM', priority: 'high' },
    { id: 2, roomId: 104, staffId: 2, status: 'in-progress', assignedAt: '2024-01-15 08:30 AM', priority: 'urgent' },
    { id: 3, roomId: 201, staffId: 3, status: 'pending', assignedAt: '2024-01-15 10:00 AM', priority: 'normal' },
  ]);

  const getStatusBadge = (status) => {
    const badges = {
      clean: { label: 'Clean', class: 'bg-green-100 text-green-700', icon: '✅' },
      dirty: { label: 'Dirty', class: 'bg-red-100 text-red-700', icon: '⚠️' },
      occupied: { label: 'Occupied', class: 'bg-blue-100 text-blue-700', icon: '👤' },
      'in-progress': { label: 'In Progress', class: 'bg-yellow-100 text-yellow-700', icon: '🔄' },
      pending: { label: 'Pending', class: 'bg-orange-100 text-orange-700', icon: '⏳' },
    };
    return badges[status] || { label: status, class: 'bg-gray-100 text-gray-700', icon: '📋' };
  };

  const getPriorityBadge = (priority) => {
    const badges = {
      urgent: { label: 'Urgent', class: 'bg-red-500 text-white' },
      high: { label: 'High', class: 'bg-orange-500 text-white' },
      normal: { label: 'Normal', class: 'bg-blue-500 text-white' },
      low: { label: 'Low', class: 'bg-gray-500 text-white' },
    };
    return badges[priority] || badges.normal;
  };

  const handleCaptureImage = (room) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.capture = 'environment';
    input.onchange = async (e) => {
      if (e.target.files[0]) {
        const file = e.target.files[0];
        const photoUrl = URL.createObjectURL(file);
        
        setDirtyRoomImages(prev => ({
          ...prev,
          [room.id]: {
            url: photoUrl,
            file: file,
            timestamp: new Date().toISOString(),
            roomId: room.id,
            floor: selectedFloor,
            uploadedBy: 'Housekeeping Staff',
            issues: room.issues || []
          }
        }));
        
        setImageUploadStatus(prev => ({
          ...prev,
          [room.id]: { uploading: true, message: 'Uploading image...' }
        }));
        
        // Simulate upload to server
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        setImageUploadStatus(prev => ({
          ...prev,
          [room.id]: { uploading: false, message: 'Image uploaded successfully!', success: true }
        }));
        
        setTimeout(() => {
          setImageUploadStatus(prev => {
            const newStatus = { ...prev };
            delete newStatus[room.id];
            return newStatus;
          });
        }, 3000);
      }
    };
    input.click();
  };

  const handleAssignTask = (roomId, staffId) => {
    const newAssignment = {
      id: assignments.length + 1,
      roomId,
      staffId,
      status: 'pending',
      assignedAt: new Date().toLocaleString(),
      priority: roomsByFloor[selectedFloor]?.find(r => r.id === roomId)?.priority || 'normal'
    };
    setAssignments([...assignments, newAssignment]);
    
    const updatedRooms = { ...roomsByFloor };
    const room = updatedRooms[selectedFloor]?.find(r => r.id === roomId);
    if (room) {
      room.assignedTo = staffList.find(s => s.id === staffId)?.name;
      room.status = 'in-progress';
    }
    setRoomsByFloor(updatedRooms);
    setShowAssignModal(false);
  };

  const handleClaimLostItem = (itemId) => {
    const updatedItems = lostFoundItems.map(item =>
      item.id === itemId ? { ...item, status: 'claimed' } : item
    );
    setLostFoundItems(updatedItems);
  };

  const handleReturnLostItem = (itemId) => {
    const updatedItems = lostFoundItems.map(item =>
      item.id === itemId ? { ...item, status: 'returned' } : item
    );
    setLostFoundItems(updatedItems);
  };

  const floors = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const renderStars = (rating) => {
    let stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i} className={i < rating ? 'text-yellow-400' : 'text-gray-300'}>
          ★
        </span>
      );
    }
    return stars;
  };

  // Get all dirty rooms across all floors for table view
  const getAllDirtyRooms = () => {
    const allDirty = [];
    floors.forEach(floor => {
      const dirtyRooms = (roomsByFloor[floor] || [])
        .filter(room => room.status === 'dirty')
        .map(room => ({
          ...room,
          floor: floor,
          image: dirtyRoomImages[room.id],
          uploadStatus: imageUploadStatus[room.id]
        }));
      allDirty.push(...dirtyRooms);
    });
    return allDirty;
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
      {/* Header */}
      <div className="flex flex-wrap justify-between items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Task Management</h1>
          <p className="text-sm text-gray-500 mt-1">Manage assignments, track progress, and handle guest feedback</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => setSelectedView('tasks')}
            className={`px-4 py-2 rounded-lg transition ${
              selectedView === 'tasks' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            📋 All Tasks
          </button>
          <button
            onClick={() => setSelectedView('assign')}
            className={`px-4 py-2 rounded-lg transition ${
              selectedView === 'assign' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            🔑 Assign Rooms
          </button>
          <button
            onClick={() => setSelectedView('dirty')}
            className={`px-4 py-2 rounded-lg transition ${
              selectedView === 'dirty' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            🧹 Dirty Rooms
          </button>
          <button
            onClick={() => setSelectedView('dirtytable')}
            className={`px-4 py-2 rounded-lg transition ${
              selectedView === 'dirtytable' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            📊 Dirty Rooms Report
          </button>
          <button
            onClick={() => setSelectedView('feedback')}
            className={`px-4 py-2 rounded-lg transition ${
              selectedView === 'feedback' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            💬 Feedback
          </button>
          <button
            onClick={() => setSelectedView('lostfound')}
            className={`px-4 py-2 rounded-lg transition ${
              selectedView === 'lostfound' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            🧳 Lost & Found
          </button>
        </div>
      </div>

      {/* Floor Navigation (for card view only) */}
      {selectedView !== 'dirtytable' && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-sm font-medium text-gray-700">Select Floor:</span>
            <div className="flex flex-wrap gap-2">
              {floors.map(floor => (
                <button
                  key={floor}
                  onClick={() => setSelectedFloor(floor)}
                  className={`w-10 h-10 rounded-lg font-medium transition ${
                    selectedFloor === floor
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {floor}
                </button>
              ))}
            </div>
          </div>
          <div className="text-sm text-gray-500">
            Floor {selectedFloor} • {roomsByFloor[selectedFloor]?.length || 0} rooms
          </div>
        </div>
      )}

      {/* Main Content Based on Selected View */}
      {selectedView === 'tasks' && (
        <div className="space-y-6">
          {/* Staff Task Overview */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">👥 Staff Task Assignments</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {staffList.map(staffMember => {
                const staffTasks = assignments.filter(a => a.staffId === staffMember.id);
                return (
                  <div key={staffMember.id} className="border rounded-lg p-4 hover:shadow-md transition">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-2xl">
                        {staffMember.avatar}
                      </div>
                      <div className="flex-1">
                        <h3 className="font-semibold text-gray-900">{staffMember.name}</h3>
                        <p className="text-xs text-gray-500">{staffMember.role} • {staffMember.shift} Shift</p>
                      </div>
                      <div className="text-right">
                        <div className="text-lg font-bold text-blue-600">{staffMember.rating}</div>
                        <div className="text-xs text-gray-500">⭐ Rating</div>
                      </div>
                    </div>
                    <div className="space-y-2">
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-600">Active Tasks:</span>
                        <span className="font-semibold">{staffTasks.length}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-600">Completed Today:</span>
                        <span className="font-semibold text-green-600">{staffMember.tasks}</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-blue-600 h-2 rounded-full" style={{ width: `${(staffTasks.length / 5) * 100}%` }} />
                      </div>
                    </div>
                    {staffTasks.length > 0 && (
                      <div className="mt-3 pt-3 border-t">
                        <p className="text-xs font-medium text-gray-700 mb-2">Assigned Rooms:</p>
                        <div className="flex flex-wrap gap-1">
                          {staffTasks.map(task => {
                            const room = Object.values(roomsByFloor).flat().find(r => r.id === task.roomId);
                            return (
                              <span key={task.id} className="inline-flex items-center gap-1 px-2 py-1 bg-gray-100 rounded text-xs">
                                {task.roomId} {room?.status === 'dirty' && '⚠️'}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Active Assignments */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">📋 Active Task Assignments</h2>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-5 py-3 text-left text-xs font-medium text-gray-500">Room</th>
                    <th className="px-5 py-3 text-left text-xs font-medium text-gray-500">Assigned To</th>
                    <th className="px-5 py-3 text-left text-xs font-medium text-gray-500">Status</th>
                    <th className="px-5 py-3 text-left text-xs font-medium text-gray-500">Priority</th>
                    <th className="px-5 py-3 text-left text-xs font-medium text-gray-500">Assigned At</th>
                    <th className="px-5 py-3 text-left text-xs font-medium text-gray-500">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {assignments.map(assignment => {
                    const staffMember = staffList.find(s => s.id === assignment.staffId);
                    const priorityBadge = getPriorityBadge(assignment.priority);
                    const statusBadge = getStatusBadge(assignment.status);
                    return (
                      <tr key={assignment.id} className="hover:bg-gray-50">
                        <td className="px-5 py-3 font-medium">Room {assignment.roomId}</td>
                        <td className="px-5 py-3">{staffMember?.name || 'Unassigned'}</td>
                        <td className="px-5 py-3">
                          <span className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full ${statusBadge.class}`}>
                            {statusBadge.icon} {statusBadge.label}
                          </span>
                        </td>
                        <td className="px-5 py-3">
                          <span className={`inline-flex px-2 py-1 text-xs rounded-full ${priorityBadge.class}`}>
                            {priorityBadge.label}
                          </span>
                        </td>
                        <td className="px-5 py-3 text-sm text-gray-500">{assignment.assignedAt}</td>
                        <td className="px-5 py-3">
                          <button className="text-blue-600 hover:text-blue-800 text-sm">View Details</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Assign Rooms View */}
      {selectedView === 'assign' && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="px-5 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">Floor {selectedFloor} Rooms</h2>
            </div>
            <div className="p-4 space-y-3">
              {roomsByFloor[selectedFloor]?.map(room => (
                <div key={room.id} className="border rounded-lg p-4 hover:shadow-md transition">
                  <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
                    <div>
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="font-bold text-lg">Room {room.id}</span>
                        <span className={`px-2 py-0.5 text-xs rounded-full ${getStatusBadge(room.status).class}`}>
                          {getStatusBadge(room.status).label}
                        </span>
                        {room.priority === 'urgent' && (
                          <span className="px-2 py-0.5 text-xs bg-red-500 text-white rounded-full animate-pulse">URGENT</span>
                        )}
                      </div>
                      {room.guestName && <p className="text-sm text-gray-500 mt-1">Guest: {room.guestName}</p>}
                    </div>
                    <button
                      onClick={() => {
                        setSelectedRoom(room);
                        setShowAssignModal(true);
                      }}
                      disabled={room.assignedTo}
                      className={`px-3 py-1.5 rounded-lg text-sm font-medium transition ${
                        room.assignedTo
                          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                          : 'bg-blue-600 text-white hover:bg-blue-700'
                      }`}
                    >
                      {room.assignedTo ? `Assigned to ${room.assignedTo}` : 'Assign Task'}
                    </button>
                  </div>
                  {room.issues && room.issues.length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-1">
                      {room.issues.map((issue, idx) => (
                        <span key={idx} className="text-xs bg-red-50 text-red-600 px-2 py-0.5 rounded">⚠️ {issue}</span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              {roomsByFloor[selectedFloor]?.length === 0 && (
                <div className="text-center py-8 text-gray-500">No rooms on this floor</div>
              )}
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="px-5 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">Available Staff</h2>
            </div>
            <div className="p-4 space-y-3">
              {staffList.map(staffMember => (
                <div key={staffMember.id} className="flex items-center gap-3 p-3 border rounded-lg hover:bg-gray-50">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-xl">
                    {staffMember.avatar}
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900">{staffMember.name}</h3>
                    <p className="text-xs text-gray-500">{staffMember.role} • {staffMember.shift} Shift</p>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs text-yellow-600">⭐ {staffMember.rating}</span>
                      <span className="text-xs text-gray-400">|</span>
                      <span className="text-xs text-gray-600">{staffMember.tasks} tasks today</span>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-medium text-green-600">{staffMember.tasks - assignments.filter(a => a.staffId === staffMember.id).length} free</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Dirty Rooms View - Card View with Image Upload */}
      {selectedView === 'dirty' && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="px-5 py-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">🧹 Dirty Rooms - Floor {selectedFloor}</h2>
            <p className="text-sm text-gray-500 mt-1">Rooms requiring immediate attention</p>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {roomsByFloor[selectedFloor]?.filter(room => room.status === 'dirty').map(room => (
                <div key={room.id} className="border-l-4 border-l-red-500 border rounded-lg p-4 hover:shadow-md transition">
                  <div className="flex justify-between items-start mb-2 flex-wrap gap-2">
                    <div>
                      <h3 className="font-bold text-lg">Room {room.id}</h3>
                      <p className="text-sm text-gray-500">Last cleaned: {room.lastCleaned}</p>
                      <p className="text-xs text-gray-400 mt-1">Reported: {room.reportedAt}</p>
                    </div>
                    <span className={`px-2 py-1 text-xs rounded-full ${getPriorityBadge(room.priority).class}`}>
                      {room.priority.toUpperCase()}
                    </span>
                  </div>
                  
                  {/* Image Upload Section */}
                  <div className="mt-3">
                    {dirtyRoomImages[room.id] ? (
                      <div className="relative">
                        <img 
                          src={dirtyRoomImages[room.id].url} 
                          alt={`Room ${room.id} dirty condition`}
                          className="w-full h-32 object-cover rounded-lg cursor-pointer"
                          onClick={() => setSelectedImageForPreview(dirtyRoomImages[room.id])}
                        />
                        <button
                          onClick={() => {
                            setDirtyRoomImages(prev => {
                              const newImages = { ...prev };
                              delete newImages[room.id];
                              return newImages;
                            });
                          }}
                          className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                        >
                          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                        {imageUploadStatus[room.id] && (
                          <div className="absolute bottom-1 left-1 right-1 bg-black bg-opacity-75 text-white text-xs p-1 rounded text-center">
                            {imageUploadStatus[room.id].message}
                          </div>
                        )}
                      </div>
                    ) : (
                      <button
                        onClick={() => handleCaptureImage(room)}
                        className="w-full h-32 border-2 border-dashed border-red-300 rounded-lg flex flex-col items-center justify-center gap-2 hover:border-red-500 hover:bg-red-50 transition"
                      >
                        <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span className="text-sm text-red-500">Capture Dirty Room Photo</span>
                      </button>
                    )}
                  </div>

                  {room.issues && room.issues.length > 0 && (
                    <div className="mt-2">
                      <p className="text-xs font-medium text-gray-700 mb-1">Issues:</p>
                      <div className="flex flex-wrap gap-1">
                        {room.issues.map((issue, idx) => (
                          <span key={idx} className="text-xs bg-red-50 text-red-600 px-2 py-0.5 rounded">{issue}</span>
                        ))}
                      </div>
                    </div>
                  )}
                  <button
                    onClick={() => {
                      setSelectedRoom(room);
                      setShowAssignModal(true);
                    }}
                    className="mt-3 w-full py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition text-sm font-medium"
                  >
                    Assign Cleaner →
                  </button>
                </div>
              ))}
              {roomsByFloor[selectedFloor]?.filter(room => room.status === 'dirty').length === 0 && (
                <div className="col-span-full text-center py-12 text-gray-500">
                  ✨ No dirty rooms on this floor! All rooms are clean.
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Dirty Rooms Report - Table View with Images */}
      {selectedView === 'dirtytable' && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="px-5 py-4 border-b border-gray-200 bg-gradient-to-r from-red-50 to-orange-50">
            <h2 className="text-lg font-semibold text-gray-900">📊 Dirty Rooms Report - All Floors</h2>
            <p className="text-sm text-gray-500 mt-1">Complete list of dirty rooms with images and assigned staff</p>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Floor</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Room No</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Guest Name</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Priority</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Issues</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Reported By</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Reported At</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Dirty Room Image</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Assigned To</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {getAllDirtyRooms().map(room => (
                  <tr key={`${room.floor}-${room.id}`} className="hover:bg-gray-50 transition">
                    <td className="px-4 py-3">
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-blue-100 text-blue-700 rounded-full font-semibold text-sm">
                        {room.floor}
                      </span>
                    </td>
                    <td className="px-4 py-3 font-bold text-gray-900">Room {room.id}</td>
                    <td className="px-4 py-3 text-gray-700">{room.guestName || 'N/A'}</td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex px-2 py-1 text-xs rounded-full ${getPriorityBadge(room.priority).class}`}>
                        {room.priority.toUpperCase()}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex flex-wrap gap-1">
                        {room.issues?.map((issue, idx) => (
                          <span key={idx} className="text-xs bg-red-50 text-red-600 px-2 py-0.5 rounded">{issue}</span>
                        )) || <span className="text-xs text-gray-400">No issues listed</span>}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">{room.reportedBy || 'Housekeeping'}</td>
                    <td className="px-4 py-3 text-sm text-gray-500">{room.reportedAt || 'N/A'}</td>
                    <td className="px-4 py-3">
                      {room.image ? (
                        <div className="relative group">
                          <img 
                            src={room.image.url} 
                            alt={`Room ${room.id}`}
                            className="w-16 h-16 object-cover rounded-lg cursor-pointer border-2 border-red-200 hover:border-red-500 transition"
                            onClick={() => setSelectedImageForPreview(room.image)}
                          />
                          <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 rounded-lg transition flex items-center justify-center cursor-pointer">
                            <span className="text-white text-xs opacity-0 group-hover:opacity-100">🔍 View</span>
                          </div>
                        </div>
                      ) : (
                        <button
                          onClick={() => handleCaptureImage(room)}
                          className="w-16 h-16 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center hover:border-red-500 hover:bg-red-50 transition"
                        >
                          <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          <span className="text-xs text-gray-400">Add</span>
                        </button>
                      )}
                    </td>
                    <td className="px-4 py-3">
                      {room.assignedTo ? (
                        <div className="flex items-center gap-1">
                          <span className="text-sm text-green-600 font-medium">{room.assignedTo}</span>
                          <span className="text-xs text-gray-400">✓</span>
                        </div>
                      ) : (
                        <span className="text-sm text-red-500">Not Assigned</span>
                      )}
                    </td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() => {
                          setSelectedRoom(room);
                          setShowAssignModal(true);
                        }}
                        disabled={room.assignedTo}
                        className={`px-3 py-1.5 rounded-lg text-xs font-medium transition ${
                          room.assignedTo
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                            : 'bg-red-600 text-white hover:bg-red-700'
                        }`}
                      >
                        {room.assignedTo ? 'Assigned' : 'Assign'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-gray-50 border-t border-gray-200">
                <tr>
                  <td colSpan="10" className="px-4 py-3">
                    <div className="flex justify-between items-center">
                      <div className="text-sm text-gray-600">
                        Total Dirty Rooms: <span className="font-bold text-red-600">{getAllDirtyRooms().length}</span>
                      </div>
                      <div className="text-sm text-gray-600">
                        Rooms with Images: <span className="font-bold text-green-600">{Object.keys(dirtyRoomImages).length}</span>
                      </div>
                      <div className="text-sm text-gray-600">
                        Assigned: <span className="font-bold text-blue-600">{getAllDirtyRooms().filter(r => r.assignedTo).length}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      )}

      {/* Customer Feedback View */}
      {selectedView === 'feedback' && (
        <div className="space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 text-center">
              <div className="text-3xl mb-2">⭐</div>
              <div className="text-2xl font-bold text-gray-900">4.5</div>
              <div className="text-sm text-gray-500">Average Rating</div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 text-center">
              <div className="text-3xl mb-2">💬</div>
              <div className="text-2xl font-bold text-gray-900">{feedbacks.length}</div>
              <div className="text-sm text-gray-500">Total Reviews</div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 text-center">
              <div className="text-3xl mb-2">✅</div>
              <div className="text-2xl font-bold text-gray-900">{feedbacks.filter(f => f.rating >= 4).length}</div>
              <div className="text-sm text-gray-500">Positive Reviews</div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 text-center">
              <div className="text-3xl mb-2">🔧</div>
              <div className="text-2xl font-bold text-gray-900">{feedbacks.filter(f => f.rating <= 2).length}</div>
              <div className="text-sm text-gray-500">Needs Improvement</div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="px-5 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">Guest Feedback & Reviews</h2>
            </div>
            <div className="divide-y divide-gray-100">
              {feedbacks.map(feedback => (
                <div key={feedback.id} className="p-5 hover:bg-gray-50 transition">
                  <div className="flex justify-between items-start mb-2 flex-wrap gap-2">
                    <div>
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="font-semibold text-gray-900">{feedback.guestName}</span>
                        <span className="text-sm text-gray-500">Room {feedback.roomId}</span>
                      </div>
                      <div className="flex items-center gap-1 mt-1">
                        {renderStars(feedback.rating)}
                      </div>
                    </div>
                    <span className="text-xs text-gray-400">{feedback.date}</span>
                  </div>
                  <p className="text-gray-700 mt-2">"{feedback.comment}"</p>
                  <div className="mt-2 flex gap-2">
                    <span className="text-xs bg-blue-50 text-blue-600 px-2 py-0.5 rounded">{feedback.category}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">📝 Add Guest Feedback</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input type="text" placeholder="Guest Name" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" />
              <input type="text" placeholder="Room Number" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" />
              <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none">
                <option>Rating 5 - Excellent</option>
                <option>Rating 4 - Good</option>
                <option>Rating 3 - Average</option>
                <option>Rating 2 - Poor</option>
                <option>Rating 1 - Terrible</option>
              </select>
              <textarea placeholder="Feedback Comment" rows="3" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none md:col-span-2"></textarea>
              <button className="md:col-span-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">Submit Feedback</button>
            </div>
          </div>
        </div>
      )}

      {/* Lost & Found View */}
      {selectedView === 'lostfound' && (
        <div className="space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 text-center">
              <div className="text-3xl mb-2">🧳</div>
              <div className="text-2xl font-bold text-gray-900">{lostFoundItems.length}</div>
              <div className="text-sm text-gray-500">Total Items</div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 text-center">
              <div className="text-3xl mb-2">⏳</div>
              <div className="text-2xl font-bold text-gray-900">{lostFoundItems.filter(i => i.status === 'pending').length}</div>
              <div className="text-sm text-gray-500">Pending Claim</div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 text-center">
              <div className="text-3xl mb-2">✅</div>
              <div className="text-2xl font-bold text-gray-900">{lostFoundItems.filter(i => i.status === 'claimed' || i.status === 'returned').length}</div>
              <div className="text-sm text-gray-500">Resolved</div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="px-5 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">Lost & Found Items</h2>
            </div>
            <div className="divide-y divide-gray-100">
              {lostFoundItems.map(item => (
                <div key={item.id} className="p-5 hover:bg-gray-50 transition">
                  <div className="flex flex-col sm:flex-row items-start justify-between gap-4">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2 flex-wrap">
                        <span className="text-2xl">
                          {item.item.includes('Phone') ? '📱' : 
                           item.item.includes('Wallet') ? '👛' : 
                           item.item.includes('Sunglasses') ? '🕶️' : 
                           item.item.includes('Charger') ? '🔌' : '🧳'}
                        </span>
                        <div>
                          <h3 className="font-semibold text-gray-900">{item.item}</h3>
                          <p className="text-sm text-gray-500">Room {item.roomId} • {item.guestName}</p>
                        </div>
                      </div>
                      <p className="text-sm text-gray-600 mb-2">{item.description}</p>
                      <div className="flex gap-2 flex-wrap">
                        <span className={`text-xs px-2 py-0.5 rounded-full ${
                          item.status === 'pending' ? 'bg-yellow-100 text-yellow-700' :
                          item.status === 'claimed' ? 'bg-blue-100 text-blue-700' :
                          'bg-green-100 text-green-700'
                        }`}>
                          {item.status === 'pending' ? '⏳ Pending' :
                           item.status === 'claimed' ? '📋 Claimed' : '✅ Returned'}
                        </span>
                        <span className="text-xs text-gray-400">{item.date}</span>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      {item.status === 'pending' && (
                        <>
                          <button
                            onClick={() => handleClaimLostItem(item.id)}
                            className="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700"
                          >
                            Mark Claimed
                          </button>
                          <button
                            onClick={() => handleReturnLostItem(item.id)}
                            className="px-3 py-1.5 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700"
                          >
                            Mark Returned
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">📝 Report Lost Item</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input type="text" placeholder="Item Name" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" />
              <input type="text" placeholder="Room Number" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" />
              <input type="text" placeholder="Guest Name" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" />
              <textarea placeholder="Description (color, brand, etc.)" rows="3" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none md:col-span-2"></textarea>
              <button className="md:col-span-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">Report Lost Item</button>
            </div>
          </div>
        </div>
      )}

      {/* Assign Task Modal */}
      {showAssignModal && selectedRoom && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={() => setShowAssignModal(false)}>
          <div className="bg-white rounded-xl max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-900">Assign Task - Room {selectedRoom.id}</h3>
              <button onClick={() => setShowAssignModal(false)} className="text-gray-400 hover:text-gray-600">✕</button>
            </div>
            <div className="space-y-4">
              <div className="p-3 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-600">Room Status: {getStatusBadge(selectedRoom.status).label}</p>
                <p className="text-sm text-gray-600 mt-1">Priority: {getPriorityBadge(selectedRoom.priority).label}</p>
                {selectedRoom.floor && <p className="text-sm text-gray-600 mt-1">Floor: {selectedRoom.floor}</p>}
              </div>
              <select
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                onChange={(e) => handleAssignTask(selectedRoom.id, parseInt(e.target.value))}
                defaultValue=""
              >
                <option value="" disabled>Select staff member</option>
                {staffList.map(staffMember => (
                  <option key={staffMember.id} value={staffMember.id}>
                    {staffMember.name} - {staffMember.role} ({staffMember.tasks} tasks today)
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      )}

      {/* Image Preview Modal */}
      {selectedImageForPreview && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4" onClick={() => setSelectedImageForPreview(null)}>
          <div className="bg-white rounded-xl max-w-2xl w-full p-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-3">
              <div>
                <h3 className="font-bold text-gray-900">Dirty Room - Room {selectedImageForPreview.roomId}</h3>
                <p className="text-xs text-gray-500">Captured: {new Date(selectedImageForPreview.timestamp).toLocaleString()}</p>
              </div>
              <button onClick={() => setSelectedImageForPreview(null)} className="text-gray-500 hover:text-gray-700">✕</button>
            </div>
            <img src={selectedImageForPreview.url} alt="Dirty room preview" className="w-full rounded-lg" />
            {selectedImageForPreview.issues && selectedImageForPreview.issues.length > 0 && (
              <div className="mt-3 p-3 bg-red-50 rounded-lg">
                <p className="text-sm font-semibold text-red-700">Issues Documented:</p>
                <div className="flex flex-wrap gap-1 mt-1">
                  {selectedImageForPreview.issues.map((issue, idx) => (
                    <span key={idx} className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded">{issue}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskManagement;